import { Outlet, Navigate } from "react-router-dom";

const AdminRoutes = (props) => {
   return props.admin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoutes;
